/**
 * @generated SignedSource<<e402ac3b5dc21f761ec24a8bd7362ae4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserPaymentMethodsTable_user$data = {
  readonly id: string;
  readonly userPaymentMethods: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isActive: boolean;
        readonly isPrimary: boolean;
        readonly methodData: any;
        readonly " $fragmentSpreads": FragmentRefs<"CardLogo_userPaymentMethod" | "UpdateUserPaymentMethodModal_userPaymentMethod">;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CreateUserPaymentMethodModal_user" | "UpdateUserPaymentMethodModal_user">;
  readonly " $fragmentType": "UserPaymentMethodsTable_user";
};
export type UserPaymentMethodsTable_user$key = {
  readonly " $data"?: UserPaymentMethodsTable_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserPaymentMethodsTable_user">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "userPaymentMethods"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": [
        "IS_PRIMARY_DESC"
      ],
      "kind": "LocalArgument",
      "name": "orderBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./UserPaymentMethodsTablePaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "UserPaymentMethodsTable_user",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "userPaymentMethods",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        }
      ],
      "concreteType": "UserPaymentMethodsConnection",
      "kind": "LinkedField",
      "name": "__UserPaymentMethodsTable_user_userPaymentMethods_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPaymentMethodsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserPaymentMethod",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isActive",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPrimary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "methodData",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CardLogo_userPaymentMethod"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UpdateUserPaymentMethodModal_userPaymentMethod"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateUserPaymentMethodModal_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateUserPaymentMethodModal_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "cd18d85d5a69e869370500e7d303da9f";

export default node;
